import { DEFAULT_FORMATTER_PATTERN, BASIC_FORMATTER_PATTERN } from '../constants';

var isEmpty = function isEmpty(arr) {
  return arr.every(function (item) {
    return !item || item === DEFAULT_FORMATTER_PATTERN.value;
  });
};

var applyStringFormatter = function applyStringFormatter(prefix, suffix) {
  var serializedSettings = '';

  if (prefix && suffix) {
    serializedSettings = prefix + '${string}' + suffix;
  } else if (prefix) {
    serializedSettings = prefix + '${string}';
  } else if (suffix) {
    serializedSettings = '${string}' + suffix;
  }

  return serializedSettings;
};

var serializeFormatterSettings = function serializeFormatterSettings(settings) {
  var prefix = settings.prefix,
      suffix = settings.suffix,
      variableType = settings.variableType;
  var shouldFormatSettings = !isEmpty(Object.values(settings));
  if (!shouldFormatSettings) return null;
  var serializedSettings = '';
  var precisionString = '';

  if (variableType === 'number') {
    var precision = settings.precision,
        operation = settings.operation,
        value = settings.value,
        separator = settings.separator;

    if (precision && precision !== DEFAULT_FORMATTER_PATTERN.value) {
      precisionString = "${number; ".concat(separator ? "0,".concat(precision) : precision);

      if (operation && value) {
        precisionString += "; ".concat(operation, "; ").concat(value);
      }

      precisionString += '}';
      serializedSettings = precisionString;
    }

    if ((!precision || precision === DEFAULT_FORMATTER_PATTERN.value) && (prefix || suffix)) {
      precisionString = BASIC_FORMATTER_PATTERN;
    }
  } else if (variableType === 'datetime') {
    var dateFormat = settings.dateFormat,
        timeFormat = settings.timeFormat;

    if (dateFormat || timeFormat || prefix || suffix) {
      precisionString = '${datetime';

      if (dateFormat && dateFormat !== 'original') {
        precisionString += ';' + dateFormat;
        if (timeFormat) precisionString += ";  ".concat(timeFormat);
      }

      precisionString += '}';
      serializedSettings = precisionString;
    }
  } else if (variableType === 'string') {
    serializedSettings = applyStringFormatter(prefix, suffix);
  }

  if (precisionString) {
    if (prefix && suffix) {
      serializedSettings = "".concat(prefix).concat(precisionString).concat(suffix);
    } else if (prefix) {
      serializedSettings = "".concat(prefix).concat(precisionString);
    } else if (suffix) {
      serializedSettings = "".concat(precisionString).concat(suffix);
    }
  }

  return serializedSettings;
};

export default serializeFormatterSettings;